//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import UserSelect from '~/components/UserSelect.vue';
import constant from '~/const';

export default {
  components: {
    UserSelect,
  },

  props: {
    value: { type: Boolean, default: false },
    routerId: { type: String, default: () => '' },
  },

  data() {
    return {
      constant,
      isOld: !process.env.VUE_APP_EXCLUDE_FEATURE.includes('transactions-old'),
      balance: '',
      amount: null,
      userId: '',
      currencyId: null,
      comment: '',
      details: '',
      errors: {
        amount: undefined,
        currencyId: undefined,
        details: undefined,
        balance: undefined,
      },
    };
  },

  computed: {
    ...mapGetters('currencies', ['getCurrencyById']),
    ...mapState('currencies', { currenciesOld: 'currencies' }),
    ...mapState('tradersCurrencies', { currencies: 'data' }),
    ...mapState('userProfile', { userProfile: 'data' }),
    ...mapState('user', ['user']),

    getCurrencies() {
      if (this.isOld) {
        return this.currenciesOld;
      }

      const { currencies } = this;
      const { balanceType } = this.userProfile;

      if (balanceType === this.constant.users.PROFILE_BALANCE_TYPE.DEBT) {
        if (constant.balance.BALANCE_DEPOSIT_TYPE[this.balance] === constant.balance.BALANCE_DEPOSIT_TYPE.Balance_Trust) {
          return currencies.filter((e) => e.title === 'USDT');
        }
        return currencies.filter((e) => e.title.startsWith('W'));
      }

      if (balanceType === this.constant.users.PROFILE_BALANCE_TYPE.LIMIT) {
        return currencies.filter((e) => e.title === 'USDT');
      }

      return currencies.filter((e) => e.title === 'USDT');
    },

    getBalanceTypes() {
      const types = [];
      const debt = constant.balance.BALANCE_DEPOSIT_TYPE_LIST[constant.balance.BALANCE_DEPOSIT_TYPE.Balance_Debt];
      // const limit = constant.balance.BALANCE_DEPOSIT_TYPE_LIST[constant.balance.BALANCE_DEPOSIT_TYPE.Balance_Limit];
      const trust = constant.balance.BALANCE_DEPOSIT_TYPE_LIST[constant.balance.BALANCE_DEPOSIT_TYPE.Balance_Trust];
      const hold = constant.balance.BALANCE_DEPOSIT_TYPE_LIST[constant.balance.BALANCE_DEPOSIT_TYPE.Balance_Hold];
      const profit = constant.balance.BALANCE_DEPOSIT_TYPE_LIST[constant.balance.BALANCE_DEPOSIT_TYPE.Balance_Profit];

      if (this.userProfile.balanceType === 0) {
        types.push(debt, trust, hold);
        if (this.user?.roles?.includes(constant.users.USER_ROLE.TRADER)) {
          types.push(profit);
        }
      }

      if (this.userProfile.balanceType === 1) {
        types.push(trust, hold, profit);
      }

      return types;
    },

    isApplyDisabled() {
      const { amount, currencyId, details } = this;
      return !amount || !currencyId || !details;
    },

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    ...mapActions('userBalanceBalances', {
      loadBalance: 'loadData',
      withdrawalBalanceAction: 'withdrawalBalance',
    }),
    ...mapActions('common', [
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
      'setGeneralProgress',
    ]),

    validate(string, field) {
      const validators = string.split(' ');
      let inError = false;
      validators.forEach((validator) => {
        switch (validator) {
          case 'require':
            if (!this[field]) {
              inError = true;
              this.errors[field] = this.$t('This field is required.');
            } else {
              inError = false;
              this.errors[field] = '';
            }
            break;
          case 'size':
            if (this[field].length >= 1024) {
              inError = true;
              this.errors[field] = this.$t('This field can`t be more 1024 characters');
            }
            if (!inError) {
              this.errors[field] = '';
            }
            break;
          default:
            break;
        }
      });
    },

    withdrawalBalance() {
      const {
        amount,
        userId,
        currencyId,
        comment,
        details,
        routerId,
        balance,
      } = this;

      if (currencyId && amount && routerId.length > 0 && details.length > 0) {
        this.confirmAction({
          title: 'Are you sure want to withdrawal balance from user?',
          hasCancelButton: true,
          callback: async () => {
            try {
              this.setGeneralProgress(true);
              if (this.isOld) {
                await this.withdrawalBalanceAction({
                  amount: Number(amount),
                  currencyId,
                  comment,
                  details,
                  userId: !routerId ? userId : routerId,
                });
              } else {
                await this.withdrawalBalanceAction({
                  userId: !routerId ? userId : routerId,
                  balance,
                  currency: currencyId,
                  amount: Number(amount),
                  comment,
                });
              }
              this.setSuccessNotification('Balance successfully withdrawn');
              await this.loadBalance();
              this.setGeneralProgress(false);
              this.closeWithdrawalBalanceModal();
            } catch (error) {
              this.setGeneralProgress(false);
              this.closeWithdrawalBalanceModal();
              this.setErrorNotification(error.message);
            }
          },
        });
      } else {
        this.setErrorNotification('Required fields are empty!');
      }
    },

    clearErrors() {
      this.errors = {
        amount: undefined,
        currencyId: undefined,
        details: undefined,
        balance: undefined,
      };
    },

    closeWithdrawalBalanceModal() {
      this.clearErrors();
      this.userId = null;
      this.amount = null;
      this.currencyId = null;
      this.comment = '';
      this.details = '';
      this.$emit('close');
    },
  },
};
